var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.arrow_previous[data-v-6f2c1c1e]{position:relative;background:transparent url(" + escape(require("../../images/arrows.png")) + ") -25px 0;width:25px;height:28px;display:block;border:0;cursor:pointer\n}\n.arrow_previous[data-v-6f2c1c1e]:hover{background-position:-25px -28px\n}\n.arrow_previous[data-v-6f2c1c1e]:active{background-position:-25px -56px\n}\n", ""]);

// exports
